
import { Component, Vue } from "vue-property-decorator";
import Template from "@/views/system-management/template/index.vue";
import { PackingWeight } from "@/model/inventory-plan";
import { HqPackingListState } from "@/model/HenganLoadingPlanModels";
import { IHqPackingListModel, IUserModel } from "@/api/types";
import { getReceiveList } from "@/api/receive-list";
import { HqPackingListAggregateInfo } from "@/model/HqPackingListModels";
import {
  addRemark,
  confirmWarehousing,
  doMatch,
  downloadInventoryListExcel,
  downloadMatchResult,
  getAllHqPackingList,
  getFactoryListByAbbreviation,
  getHqPackingListStates,
  reUploadPackingList,
  uploadPackingList,
  getCustomerPackingManagement
} from "@/api/hq-packing-list";
import { getUsersByJobPosition } from "@/api/users";
import Pagination from "@/components/Pagination/index.vue";
import { Message } from "element-ui";
import { ElUploadInternalFileDetail } from "element-ui/types/upload";
import { HqPackingListType } from "@/commons/HqPackingListType";
import CustomsPackingStatistics from "@/views/components/CustomsPackingStatistics.vue";
import HqPackingListProductList from "@/views/components/HqPackingListProductList.vue";
import { exportJson2Excel } from "@/utils/excel";
import { formatJson } from "@/utils";
import { getDeliveryVerificationList } from "@/api/purchase-order";

import { getCanReUpload } from "@/api/hq-packing-list";

import { getAbbreviation } from "@/api/supplier";

import { updatePaymentOrder } from "@/api/supplier-payment"

import {
  createFactoryDeliveryNote,
  getFactoryDeliveryNote,
  getFactoryDeliveryNoteOriginalInfo,
  getFactoryDeliveryNoteDetail,
  downFactoryDeliveryNote,
} from "@/api/factory-delivery-note";
import { cal } from "@/utils/cal";
import { create } from "lodash";

@Component({
  name: "HqPackingListControl",
  components: {
    Template,
    Pagination,
    CustomsPackingStatistics,
    CreateFee: () =>
      import("./other-expenses-management/components/CreateFee.vue"),
    HqPackingListProductList,
  },
})
export default class extends Vue {
  private total = 0;
  private listQuery = {
    parentCode: null,
    hqPackingListCode: null,
    factoryId: null,
    state: null,
    auditState: null,
    purchaseOrderNumber: null,
    purchaserId: null,
    sellerId: null,
    stayDays: null,
    exception:null,
    pageNumber: 1,
    pageSize: 20,
  };
  private exceptionOptions = [
    {
      label: "异常",
      value: true,
    }
  ];
  private showDepositSurplus = false;
  private listLoading = false;
  private showAllRow = false;
  //批量上传
  private batchUploadDialogVisible = false;
  private showFileList = false;
  private buttonLoading = false;
  private files: any[] = [];

  private currentRow: any = {};
  private factoryDeliveryNoteDialogStatus = "";

  //工厂名称
  private isLoadingFactory = false;

  //备注
  private addRemarkDialogVisible = false;
  private hqPackingListRemark = "";
  private hqPackingListRemarkId = "";

  //查看入库单
  private hqPackingRow: HqPackingListData = new HqPackingListData();
  private receiveListDialogVisible = false;
  private receiveList: HqPackingListAggregateInfo =
    new HqPackingListAggregateInfo();

  private hqPackingListStates: any[] = [];
  private hqPackingListauditStates = [
    { name: "PENDING_AUDIT", desc: "待审核" },
    { name: "APPROVED", desc: "已通过" },
    { name: "SUSPENDED", desc: "已挂起" },
  ];
  private purchaserList: IUserModel[] = [];
  private sellerList: IUserModel[] = [];
  private factoryList: any[] = [];
  private hqPackingLists:any = [];
  private hqPackingListType = "DELIVERY_NOTE";
  private hqPackingListIdROW = "";

  FACTORY_DELIVERY_NOTE_DIALOG_TITLE_MAP = {
    create: "生成子进仓单",
    check: "查看子进仓单",
  };
  public loading: Boolean = false;
  private showOtherMoneyDialog = false;
  private factoryDeliveryNote: FactoryDeliveryNoteModel =
    new FactoryDeliveryNoteModel();
  private createFactoryDeliveryNoteRequest: CreateFactoryDeliveryNoteRequest =
    new CreateFactoryDeliveryNoteRequest();
  private factoryDeliveryNoteDialogVisible = false;
  private seeDeliveryverificationresultsShow = false;

  public tableCol = [
    {
      label: "采购订单号",
      prop: "purchaseOrderNumber",
      key: "purchaseOrderNumber",
      show: true,
      disabled: false,
      fixed: true,
      // type: "link",
      width: 130,
    },
    {
      label: "客人号码1",
      prop: "customerNumber",
      key: "customerNumber",
      show: true,
    },
    {
      label: "华强交易号码",
      prop: "hqTransactionNumber",
      key: "hqTransactionNumber",
      show: true,
    },
    {
      label: "OE号码",
      prop: "oeNumber",
      key: "oeNumber",
      show: true,
    },
    {
      label: "REF",
      prop: "refNumber",
      key: "refNumber",
      show: true,
    },
    {
      label: "未上传数量",
      prop: "noUploadedQuantity",
      key: "noUploadedQuantity",
      show: true,
    },
    {
      label: "装箱单数量",
      prop: "quantity",
      key: "quantity",
      show: true,
    },
    {
      label: "剩余未交货",
      prop: "noDeliveryQuantity",
      key: "noDeliveryQuantity",
      show: true,
      type: "actions",
      options: [
        {
          prop: "noDeliveryQuantity",
          type: "text",
        },
        {
          name: "超发",
          code: "",
          click: "handleOver",
          key: "showMore",
          value: true,
        },
        {
          name: "欠发",
          code: "",
          click: "handleUnder",
          key: "showLess",
          value: true,
        },
      ],
      width: 120,
    },
    {
      label: "下单金额",
      prop: "poUnitPrice",
      key: "poUnitPrice",
      show: true,
      disabled: false,
    },
    {
      label: "装箱单金额",
      prop: "productUnitPrice",
      key: "productUnitPrice",
      show: true,
      disabled: false,
    },
    {
      label: "校验结果",
      prop: "result",
      key: "result",
      show: true,
      disabled: false,
    },
  ] as any;
  private table = {
    total: 0,
    pageNumber: 1,
    pageSize: 20,
    list: [] as any[],
  };

  created() {
    if (this.$route.query.code) {
      this.listQuery.hqPackingListCode = this.$route.query.code;
    } else if(this.$route.params.code) {
      this.listQuery.hqPackingListCode = this.$route.params.code;
    }
    this.init();
  }

  private init() {
    this.initSellerList();
    this.initPurchaserList();
    // this.initHqPackingListStates();
    this.getCustomerPackingManagement();
    this.getList();
  }

  private async getJiaoYanList(packingListId) {
    this.loading = true;
    const params = {
      packingListId: packingListId,
    };
    const res: any = await getDeliveryVerificationList(params);
    res.forEach((item) => {
      this.getNoDeliveryQuantity(item);
    });
    this.table.total = res.length;
    this.table.list = res;
    this.loading = false;
  }

  private getNoDeliveryQuantity(item) {
    if (!item.noUploadedQuantity || !item.quantity) {
      return;
    }
    // 未上传数量-装箱单数量
    const noDeliveryQuantity = +cal.jian(
      item.noUploadedQuantity,
      item.quantity
    );
    this.$set(item, "noDeliveryQuantity", noDeliveryQuantity);
    if (noDeliveryQuantity < 0 && item.result.indexOf("超发") > -1) {
      this.$set(item, "showMore", true);
    }
    if (noDeliveryQuantity > 0 && item.result.indexOf("订单未完成") > -1) {
      this.$set(item, "showLess", true);
    }
  }

  private exportExcelJioaYan() {
    const data = this.table.list.map((value) => {
      return {
        ...value,
      };
    });
    const headers = [
      "采购订单号",
      "客人号码1",
      "华强交易号码",
      "OE号码",
      "REF",
      "未上传数量",
      "装箱单数量",
      "剩余未交货",
      "下单金额",
      "装箱单金额",
      "校验结果",
    ];
    const fieldNames = [
      "purchaseOrderNumber",
      "customerNumber",
      "hqTransactionNumber",
      "oeNumber",
      "refNumber",
      "noUploadedQuantity",
      "quantity",
      "noDeliveryQuantity",
      "poUnitPrice",
      "productUnitPrice",
      "result",
    ];
    exportJson2Excel(
      headers,
      formatJson(fieldNames, data),
      `交货校验结果-${new Date()}`
    );
  }

  private async getCustomerPackingManagement() {
    await getCustomerPackingManagement().then((res:any) => {
      this.hqPackingListStates = res
    }).catch(err => {
      console.log(err);
    })
  }

  private async clickSubmit(type: string) {
    this.hqPackingListType = type;
    this.$refs["upload"]["$refs"]["upload-inner"].handleClick();
  }

  private async getList() {
    this.listLoading = true;
    const { content, total }: any = await getAllHqPackingList(this.listQuery);
    this.total = total;
    this.hqPackingLists = content;
    this.hqPackingLists.map((item,index) => {item.sn = index + 1});
    this.listLoading = false;
  }

  private async toggleColumns() {
    this.listLoading = true;
    await new Promise(resolve => setTimeout(resolve, 50));
    this.showAllRow = !this.showAllRow
    this.listLoading = false;
  }

  private async initSellerList() {
    const data: any = await getUsersByJobPosition("seller");
    this.sellerList = data;
  }

  private async initPurchaserList() {
    const data: any = await getUsersByJobPosition("purchaser");
    this.purchaserList = data;
  }

  private async initHqPackingListStates() {
    const data: any = await getHqPackingListStates();
    this.hqPackingListStates = data;
  }

  private exportExcel() {
    const data = this.hqPackingLists.map((value) => {
      return {
        ...value,
        packingState: value.state.desc,
        grossWeight: value.packingWeight.grossWeight,
        netWeight: value.packingWeight.netWeight,
        confirmType:
          value.confirmType === null
            ? null
            : value.confirmType === 1
            ? "手动入库"
            : "扫码入库",
      };
    });
    const headers = [
      "装箱单号",
      "客户简称",
      "工厂简称",
      "状态",
      "进仓单号",
      "毛重",
      "净重",
      "体积",
      "产品总数量",
      "主包装件数",
      "包装",
      "采购订单号",
      "负责采购员",
      "负责销售员",
      "最终上传日期",
      "匹配入库时间",
      "入库者",
      "入库方式",
      "备注",
    ];
    const fieldNames = [
      "hqPackingListCode",
      "customerAbbreviation",
      "factoryAbbreviation",
      "packingState",
      "parentCode",
      "grossWeight",
      "netWeight",
      "volume",
      "totalProductPcs",
      "customsPackingQuantity",
      "packingType",
      "purchaseOrderNumber",
      "purchaserName",
      "sellerName",
      "createAt",
      "warehouseInTime",
      "whoConfirm",
      "confirmType",
      "remark",
    ];
    exportJson2Excel(
      headers,
      formatJson(fieldNames, data),
      `装箱单管理-${new Date()}`
    );
  }

  private async getFactoryList(value: string) {
    const data: any = await getFactoryListByAbbreviation({
      abbreviation: value,
    });
    this.factoryList = data;
  }

  private async reUploadToPage(row) {
    await getCanReUpload(row.hqPackingListId).then((res) => {
      this.$router.push({
        name: "UploadFactoryPackingList",
        query: {
          id: row.hqPackingListId,
          code: row.hqPackingListCode,
          parentCode: row.parentCode,
        },
      });
    });
  }

  private gotoDocumentFlow(data) {
    this.$router.push({
      name: "DocumentFlow",
      params: { type: "HQ_PACKING_LIST", documentId: data.hqPackingListId },
    });
  }

  // 特此说明一下 因为跳转的页面没有用到parentId 但是因为路由里面写了 又必须得传 所以传了个1 不要问为什么
  private gotoPackingListDetailPage(id: string, type: string) {
    this.$router.push({
      name: "HqPackingListDetail",
      params: { hqPackingListId: id, type: type,parentId: '1' },
    });
  }

  private async updatePaymentOrder(id) {
    let params = {
      hqPackingListId: id
    }
    const loading = this.$loading({
      lock: true,
      text: 'Loading',
      spinner: 'el-icon-loading',
      background: 'rgba(0, 0, 0, 0.7)'
    });
    await updatePaymentOrder(params).then(res => {
      this.getList();
      loading.close();
      this.$notify({
        title: "成功",
        message: "更新付款单成功！",
        type: "success",
        duration: 2000,
      });
    }).catch(err => {
      console.log(err);
      loading.close();
    })
  }

  private gotoEditPage(id: string) {
    this.$router.push({
      name: "HqPackingListDetailForEdit",
      params: { hqPackingListId: id },
    });
  }

  public OtherMoneyDialog(row) {
    // this.showOtherMoneyDialog = true;
    // this.hqPackingListIdROW = row.hqPackingListId;
    console.log('row',row)
    this.$router.push(`/otherExpensesManagement?hqPackingListId=${row.hqPackingListId}&supplierId=${row.supplierId}&hqCode=${row.hqPackingListCode}&status=${row.state.desc}&pageState=HqPackingList`);
  }

  private handleSuccess() {
    this.showOtherMoneyDialog = false;
  }

  private gotoImageManagementPage(id: string) {
    this.$router.push({
      name: "ImageManagement",
      params: { bizType: "hq-packing-list", objectId: id },
    });
  }
  // 创建付款单
  private async createPaymentOrder(row) {
    let params = {
      abbreviation: row.factoryAbbreviation,
    };
    const res = await getAbbreviation(params);
    if (res) {
      this.$router.push({
        name: "createPaymentOrder",
        query: {factoryAbbreviationName: row.factoryAbbreviation, factoryAbbreviationID: res[0].id, hqPackingListCode: row.hqPackingListCode,type: 'ToList',codesType: 'HQ_PACKING_LIST',hqPackingListId: row.hqPackingListId,showBtnStatus: 'false'},
      });
    }
  }

  private handleRemove(
    file: ElUploadInternalFileDetail,
    fileList: ElUploadInternalFileDetail[]
  ) {
    this.files = fileList.filter((value) => value.name !== file.name);
  }

  private clearFiles() {
    this.files = [];
    this.batchUploadDialogVisible = false;
  }

  private async doAddRemark() {
    await addRemark(this.hqPackingListRemarkId, {
      remark: this.hqPackingListRemark,
    });
    this.addRemarkDialogVisible = false;
    this.$notify({
      title: "成功",
      message: "操作成功",
      type: "success",
      duration: 2000,
    });
    await this.getList();
  }

  private async handleUpload() {
    this.buttonLoading = true;
    let formData = new window.FormData();
    formData.append("files", this.files.pop());
    // formData.append("code", this.hqPackingListParentInfo.code);
    if (this.hqPackingListType === "DELIVERY_NOTE") {
      formData.append("type", HqPackingListType.DELIVERY_NOTE.toUpperCase());
    } else {
      formData.append(
        "type",
        HqPackingListType.FACTORY_LOADING_PLAN.toUpperCase()
      );
    }
    await uploadPackingList(formData)
      .then(() => {
        this.buttonLoading = false;
      })
      .catch(() => {
        this.buttonLoading = false;
      });
    this.clearFiles();
    await this.getList();
  }

  private async showFactoryDeliveryNoteDialog(row) {
    console.log("点击的row", row);
    this.buttonLoading = true;
    this.currentRow = row;
    this.factoryDeliveryNoteDialogStatus = row.factoryDeliveryNoteId
      ? "check"
      : "create";
    if (this.factoryDeliveryNoteDialogStatus === "check") {
      const data: any = await getFactoryDeliveryNote(row.hqPackingListId).catch(
        () => {
          this.buttonLoading = false;
        }
      );
      this.factoryDeliveryNote = data;
      if (!this.factoryDeliveryNote.factoryDeliveryNote.remark) {
        this.factoryDeliveryNote.factoryDeliveryNote.remark = "";
      }
      this.buttonLoading = false;
      this.factoryDeliveryNoteDialogVisible = true;
    } else {
      await createFactoryDeliveryNote(row.hqPackingListId);
      this.buttonLoading = false;
      this.getList();
    }
  }

  private onFactoryDeliveryNoteDialogConfirmed(row: IHqPackingListModel) {
    if (this.factoryDeliveryNoteDialogStatus === "create") {
      this.doCreateFactoryDeliveryNote(row.id);
    } else if (this.factoryDeliveryNoteDialogStatus === "check") {
    }
  }

  private async doCreateFactoryDeliveryNote(hqPackingListId: string) {
    const timeRange: Date[] =
      this.createFactoryDeliveryNoteRequest.warehouseInTimeRange;
    this.createFactoryDeliveryNoteRequest.warehouseInStartTime = timeRange[0];
    this.createFactoryDeliveryNoteRequest.warehouseInEndTime = timeRange[1];
    await createFactoryDeliveryNote(hqPackingListId);
    this.factoryDeliveryNoteDialogVisible = false;
    this.$notify({
      title: "成功",
      message: "操作成功",
      type: "success",
      duration: 2000,
    });
    await this.getList();
  }

  private async handleBatchUpload() {
    let formData = new window.FormData();
    this.files.forEach((file) => formData.append("files", file.raw));
    if (this.hqPackingListType === "DELIVERY_NOTE") {
      formData.append("type", HqPackingListType.DELIVERY_NOTE.toUpperCase());
    } else {
      formData.append(
        "type",
        HqPackingListType.FACTORY_LOADING_PLAN.toUpperCase()
      );
    }
    await uploadPackingList(formData)
      .then(() => {
        this.batchUploadDialogVisible = false;
      })
      .catch(() => {
        this.batchUploadDialogVisible = false;
      });
    this.$notify({
      title: "成功",
      message: "操作成功",
      type: "success",
      duration: 2000,
    });
    this.clearFiles();
    await this.getList();
  }

  private handleReUpload() {
    if (this.files.length == 0) {
      return;
    }
    this.doReUpload();
  }

  private async doReUpload() {
    let formData = new window.FormData();
    formData.append("file", this.files.pop());
    await reUploadPackingList(this.currentRow.hqPackingListId, formData);
    this.clearFiles();
    await this.getList();
  }

  private addFile(file: any) {
    if (file.size / 1024 / 1024 >= 100) {
      Message({
        message: "上传的文件大小不能超过100M!",
        type: "error",
        duration: 2 * 1000,
      });
    }
    this.files.push(file);
  }

  private showAddRemarkDialog(row: HqPackingListData) {
    this.hqPackingListRemark = row.remark;
    this.hqPackingListRemarkId = row.hqPackingListId;
    this.addRemarkDialogVisible = true;
  }

  private seeDeliveryverificationresults(row) {
    this.seeDeliveryverificationresultsShow = true;
    this.getJiaoYanList(row.hqPackingListId);
  }

  private async downloadFactoryDeliveryNote(hqPackingListId: string) {
    await downFactoryDeliveryNote(hqPackingListId).catch(() => {
      return Message.error({ message: "下载出错，请重新尝试" });
    });
  }

  private async doMatch(row: IHqPackingListModel) {
    await doMatch({ hqPackingListCode: row.code }).then((value: any) => {
      if (value === true) {
        this.$msgbox({
          title: "消息",
          message: "匹配成功，是否确认入库",
          showCancelButton: true,
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          beforeClose: (action, instance, done) => {
            if (action === "confirm") {
              instance.confirmButtonLoading = true;
              instance.confirmButtonText = "执行中...";
              confirmWarehousing({ ids: [row.id] });
              done();
            } else {
              done();
            }
          },
        });
      } else {
        this.$message({
          showClose: true,
          message: "匹配失败",
          type: "error",
        });
      }
    });
    await this.getList();
  }

  private canShowDataColumns() {
    if (
      this.$route.meta.buttonCodes &&
      Array.isArray(this.$route.meta.buttonCodes)
    ) {
      return this.$route.meta.buttonCodes.includes("dataColumns");
    }
  }

  // 查看入库清单
  private showCheckReceiveListDialog(row: HqPackingListData) {
    this.receiveListDialogVisible = true;
    this.hqPackingRow = row;
    this.getReceiveListData(row.hqPackingListId);
  }

  private async getReceiveListData(hqPackingListId: string) {
    const data: any = await getReceiveList(hqPackingListId);
    this.receiveList = data;
  }

  // 下载入库清单
  private async downloadInventoryList(code: string) {
    await downloadInventoryListExcel(code);
  }

  // 下载匹配结果
  private async downloadMatchResult(code: string) {
    await downloadMatchResult(code);
  }
}

class HqPackingListData {
  hqPackingListCode: string;
  hqPackingListId: string;
  customerAbbreviation: string;
  factoryAbbreviation: string;
  state: HqPackingListState;
  auditState: HqPackingListState;
  parentCode: string;
  createAt: string;
  warehouseInTime: string;
  packingWeight: PackingWeight;
  volume: string;
  totalProductPcs: number;
  customsPackingQuantity: number;
  // CTN/PLT
  packingType: string;
  purchaseOrderNumber: string;
  purchaserName: string;
  sellerName: string;
  // 报关计划/进仓单
  parentType: string;
  remark: string;
  whoConfirm: string;
  confirmType: number; // 1:手动入库  2:扫码入库
}
class FactoryDeliveryNoteModel {
  factoryDeliveryNote: FactoryDeliveryNote = new FactoryDeliveryNote();
  currentDate: string;
}
class FactoryDeliveryNote {
  hqPackingListId: string;
  factoryName: string;
  deliveryNoteCode: string;
  deliveryStartTime: string;
  deliveryEndTime: string;
  hqPackingListCode: string;
  storageLayerName: string;
  purchaseOrderNumbers: string;
  descriptions: string;
  shippingMark: string;
  productQuantity: number;
  selfCode: string;
  palletQuantity: number;
  cartonQuantity: number;
  customsPackingQuantity: number;
  volume: string;
  grossWeight: string;
  remark: string;
  purchaserName: string;
}

class CreateFactoryDeliveryNoteRequest {
  hqPackingListId: string;
  carriageVehicleType: string;
  warehouseInStartTime: Date;
  warehouseInEndTime: Date;
  deliveryLicensePlateNumber: string;
  deliveryDriverTel: string;
  warehouseInTimeRange: Date[];
}
